import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { peoplePlatformPhotoApi } from '~/shared/services/api';

async function getProfilePicture(globalId?: string) {
  try {
    const { data } = await peoplePlatformPhotoApi.get<Blob>(
      `/photo/thumb/${globalId}`,
      {
        responseType: 'blob'
      }
    );

    return data;
  } catch {
    return null;
  }
}

export function useGetProfilePicture(globalId: string) {
  const query = useQuery({
    queryKey: ['getProfilePicture', globalId],
    queryFn: () => getProfilePicture(globalId),
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: false,
    retryOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!globalId && globalId.length > 0
  });

  const [imageSrc, setImageSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!query.data) {
      setImageSrc(null);
      return;
    }

    const objectUrl = URL.createObjectURL(query.data);
    setImageSrc(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [query.data]);

  return Object.assign(query, {
    imageSrc
  });
}
